import { PureComponent, ReactNode } from "react";

export interface IOpenableWrappedProps {
  open: boolean;
  showOpenable: () => void;
  hideOpenable: () => void;
}

export interface IOpenableWrapperProps {
  initialOpen?: boolean;
  children: (props: IOpenableWrappedProps) => ReactNode;
}

export interface IOpenableWrapperState {
  isOpen: boolean;
}

export class OpenableWrapper extends PureComponent<IOpenableWrapperProps, IOpenableWrapperState> {
  state: IOpenableWrapperState = { isOpen: this.props.initialOpen || false };

  showOpenable = () => {
    this.setState({ isOpen: true });
  };

  hideOpenable = () => {
    this.setState({ isOpen: false });
    return;
  };

  render() {
    const { children } = this.props;
    const { isOpen } = this.state;

    return children({ open: isOpen, showOpenable: this.showOpenable, hideOpenable: this.hideOpenable });
  }
}
